import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Button, Icon } from "semantic-ui-react";
import AssistantCcEmail from "./AssistantCcEmail";

@observer
class AssistantCcEmailList extends Component {
  updateEmail(index, value) {
    const { onChange, emails } = this.props;

    emails.splice(index, 1, value);
    onChange(emails);
  }

  addEmailRow() {
    const { onChange, emails } = this.props;

    emails.push("");
    onChange(emails);
  }

  deleteEmail(email, index) {
    const { emails, onChange } = this.props;
    emails.splice(index, 1);
    onChange(emails);
  }

  render() {
    const { emails, t } = this.props;
    const actualEmails = emails.length > 0 ? emails : [""];
    return (
      <div>
        <Button type="button" onClick={() => this.addEmailRow()} style={{ marginBottom: "1.5em" }}>
          <Icon name="add" />
          {t("addEmails")}
        </Button>
        {actualEmails.map((email, index) => (
          <AssistantCcEmail
            /* eslint-disable-next-line react/no-array-index-key */
            key={index}
            address={email}
            onChange={value => this.updateEmail(index, value)}
            deleteEmail={() => this.deleteEmail(email, index)}
          />
        ))}
      </div>
    );
  }
}

AssistantCcEmailList.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

AssistantCcEmailList.defaultProps = {
  emails: [],
};

export default withTranslation()(AssistantCcEmailList);
